import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HoverElevationDirective } from './hover-elevation.directive';
import { PermissionModuleDirective } from './permission-module.directive';
import { ButtonActionsDirective } from './button-actions.directive';
import { NumbersOnlyDirective } from './numbersonly.directive';
// import { PreventCopyPasteDirective } from './prevent-copy-paste.directive';

@NgModule({
  declarations: [
    HoverElevationDirective,
    PermissionModuleDirective,
    ButtonActionsDirective,
    NumbersOnlyDirective
    // PreventCopyPasteDirective,
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HoverElevationDirective,
    PermissionModuleDirective,
    ButtonActionsDirective,
    // PreventCopyPasteDirective,
  ]
})
export class DirectivesModule { }
